var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card card-default" },
    [
      _vm.guide.is_editing
        ? _c("vue-form", { staticClass: "card-body" })
        : _vm._e(),
      _vm._v(" "),
      !_vm.guide.is_editing
        ? _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm.guide.permissions.update
                ? _c("div", { staticClass: "dropdown float-right" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu dropdown-menu-right" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.edit },
                          },
                          [
                            _c("i", { staticClass: "fas fa-edit fa-fw" }),
                            _vm._v(" Edytuj"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: { href: "javascript:" },
                            on: { click: _vm.deleteItem },
                          },
                          [
                            _c("i", { staticClass: "fas fa-times fa-fw" }),
                            _vm._v(" Usuń"),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("h1", { staticClass: "m-0" }, [
                _c("a", { attrs: { href: _vm.guide.url } }, [
                  _vm._v(_vm._s(_vm.guide.title)),
                ]),
              ]),
              _vm._v(" "),
              _c("vue-metadata", { attrs: { guide: _vm.guide } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row no-gutters" },
                [
                  _c("vue-tags", {
                    staticClass: "mt-2 mb-2",
                    attrs: { tags: _vm.guide.tags },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ml-auto text-right" },
                    [
                      _c(
                        "p",
                        { staticClass: "text-muted font-weight-bold mb-1" },
                        [
                          _c("i", { staticClass: "fas fa-fw fa-chart-line" }),
                          _vm._v(" " + _vm._s(_vm.seniorityLabel)),
                        ]
                      ),
                      _vm._v(" "),
                      _c("vue-progress-bar", {
                        attrs: {
                          editable: true,
                          tooltips: Object.values(_vm.roles),
                          "data-popover":
                            '{"message": "Możesz zmienić typ tej roli jeżeli się z nią nie zgadzasz.", "placement": "left", "offset": [0, 20]}',
                        },
                        on: { click: _vm.setRole },
                        model: {
                          value: _vm.progressBarValue,
                          callback: function ($$v) {
                            _vm.progressBarValue = $$v
                          },
                          expression: "progressBarValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "mt-3",
                domProps: { innerHTML: _vm._s(_vm.guide.excerpt_html) },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "guide-text" }, [
                _c("div", {
                  class: { blur: !_vm.isShowing },
                  domProps: { innerHTML: _vm._s(_vm.guide.html) },
                }),
                _vm._v(" "),
                !_vm.isShowing
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function ($event) {
                            _vm.isShowing = true
                          },
                        },
                      },
                      [_vm._v("Zobacz odpowiedź")]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 pt-3 border-top" }, [
                _c("ul", { staticClass: "list-inline mb-2" }, [
                  _c("li", { staticClass: "list-inline-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-gradient",
                        attrs: {
                          href: "javascript:",
                          title:
                            "Kliknij jeżeli uważasz ten wpis za wartościowy",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.checkAuth(_vm.vote, _vm.guide)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-fw fa-thumbs-up",
                          class: {
                            "fa text-primary": _vm.guide.is_voted,
                            far: !_vm.guide.is_voted,
                          },
                        }),
                        _vm._v(
                          "\n\n            " +
                            _vm._s(_vm.guide.votes) +
                            " " +
                            _vm._s(
                              _vm._f("declination")(_vm.guide.votes, [
                                "głos",
                                "głosy",
                                "głosów",
                              ])
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "list-inline-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-gradient",
                        attrs: {
                          href: "javascript:",
                          title:
                            "Otrzymuj powiadomienia o zmianach na tej stronie",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.checkAuth(_vm.subscribe, _vm.guide)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-fw fa-bell",
                          class: {
                            "fa text-primary": _vm.guide.is_subscribed,
                            far: !_vm.guide.is_subscribed,
                          },
                        }),
                        _vm._v(
                          "\n\n            " +
                            _vm._s(_vm.guide.subscribers) +
                            " " +
                            _vm._s(
                              _vm._f("declination")(_vm.guide.subscribers, [
                                "obserwator",
                                "obserwatorów",
                                "obserwatorów",
                              ])
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-xs border-0 text-muted mt-2",
        attrs: {
          type: "button",
          "data-bs-toggle": "dropdown",
          "aria-label": "Dropdown",
        },
      },
      [_c("i", { staticClass: "fa fa-ellipsis-h" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }